<div>

  <div class="print-button">
    <button fmButton type="button" label="Print View" [small]="true" (click)="printComponent()"
            class="buttonmargin"></button>
  </div>

  <div id="printview" *ngIf="responseDetails!=null">
    <div class="pageHeader" id="loanDetailsHeader">Loan Details</div>

    <div *ngIf="responseDetails.loanEntityValue.warningList!=null">
      <div class="populated-Error-Msg" *ngIf="responseDetails.loanEntityValue.warningList?.length > 0">
        <p> Loan saved with following warnings :</p>
        <div *ngFor="let warnings of responseDetails.loanEntityValue.warningList">
          <li>{{warnings.populatedErrorMsg}}</li>
        </div>
      </div>
    </div>

    <div *ngIf="responseDetails.loanEntityValue.errorList!=null">
      <div class="populated-Error-Msg" *ngIf="responseDetails.loanEntityValue.errorList?.length > 0">
        <p> Loan saved with following errors :</p>
        <div *ngFor="let errors of responseDetails.loanEntityValue.errorList">
          <li>{{errors.populatedErrorMsg}}</li>
        </div>
      </div>
    </div>

    <!-- Contact Information -->

    <div class="ui-g container grid-conatiner">

      <div class="ui-g-12 grid-header">Contact Information</div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Seller Number:</div>
        <div class="ui-g-2"> {{responseDetails.loanEntityValue.sellerNo}} </div>
        <div class="ui-g-8"></div>
      </div>


      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Contact Name:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.sellerObject.contactName}}</div>
        <div class="ui-g-2 label-font">Contact Phone #:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.sellerObject.contactPhoneNumber}}</div>
        <div class="ui-g-2 label-font"> Contact Fax #:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.sellerObject.contactFaxNumber}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Servicer Number:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.srvrno}}</div>
        <div class="ui-g-8"></div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Contact Name:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.servicerObject.contactName}}</div>
        <div class="ui-g-2 label-font">Contact Phone #:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.servicerObject.contactPhoneNumber}}</div>
        <div class="ui-g-2 label-font"> Contact Fax #:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.servicerObject.contactFaxNumber}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">SubServicer Number:</div>
        <div class="ui-g-2"> <span *ngIf="responseDetails.loanEntityValue.subsrvcrno!='0'"> {{responseDetails.loanEntityValue.subsrvcrno}} </span></div>
        <div class="ui-g-8"></div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Contact Name:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.subsrvcrName}}</div>
        <div class="ui-g-2 label-font">Contact Phone #:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.subsrvcrPhone}}</div>
        <div class="ui-g-2 label-font"> Contact Fax #:</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.subsrvcrFax}}</div>
      </div>

    </div>

    <!-- Loan Information -->

    <div class="ui-g container grid-conatiner">

      <div class="ui-g-12 grid-header">Loan Information</div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Lender Loan ID</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lndrLnNo}}</div>
        <div class="ui-g-2 label-font">Funding Date</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.lnFndgDt!=null">{{responseDetails.loanEntityValue.lnFndgDt.date}}</span>
        </div>
        <div class="ui-g-2 label-font">Other Closing Cost</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnClsngCostsOthAmt | currency}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Fannie Mae Loan #</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.fanniemaeLnNumber}}</div>
        <div class="ui-g-2 label-font">Rounding</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnRndgInd}}</div>
        <div class="ui-g-2 label-font">1st Adjustment Date</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.lnFstPiPmtChgDt!=null">{{responseDetails.loanEntityValue.lnFstPiPmtChgDt.date}}</span>
        </div>
      </div>


      <div class="ui-g-12 ">
        <div class="ui-g-2 label-font">Old Fannie Mae Loan #</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.oldFnmaNo}}</div>
        <div class="ui-g-2 label-font">Origination Fee</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnOrgnFeeAmt | currency}}</div>
        <div class="ui-g-2 label-font"> Payment Plan</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnPmtPlanTypCd}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">First Disbr. Date</div>
        <div class="ui-g-2"> <span *ngIf="responseDetails.loanEntityValue.lnFstDsbtDt!=null"> {{responseDetails.loanEntityValue.lnFstDsbtDt.date}}</span></div>
        <div class="ui-g-2 label-font">Lien Advances</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnLienAdvAmt | currency}}</div>
        <div class="ui-g-2 label-font">Contract Number</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.ctrtNo}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Other Draws</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnDrawOthAmt | currency}}</div>
        <div class="ui-g-2 label-font">Repairs Set Aside</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnRprSetaAmt | currency}}</div>
        <div class="ui-g-2 label-font">First Yr Prop Charge</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.propFstYrAmt | currency}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Product Type</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.prdctTypCd}}</div>
        <div class="ui-g-2 label-font">Initial Index</div>
        <div class="ui-g-2">
      <span
        *ngIf="responseDetails.loanEntityValue.lnIdxRt!=null">{{responseDetails.loanEntityValue.lnIdxRt.amount }}%</span>
        </div>
        <div class="ui-g-2 label-font">Maturity</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnMtryTermMths}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">FHA Case Number</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.fhaCaseNo}}</div>
        <div class="ui-g-2 label-font">Closing Date</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.lnSchdClsngDt!=null">{{responseDetails.loanEntityValue.lnSchdClsngDt.date}}</span>
        </div>
        <div class="ui-g-2 label-font">Servicing Fee</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnSrvgFeeAmt | currency}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Expected Avg Rate Index</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.expdAvgIdxRt!=null">{{responseDetails.loanEntityValue.expdAvgIdxRt.amount}}%
           </span></div>
        <div class="ui-g-2 label-font">Net Line Of Credit</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.netLocRsrvAmt | currency}}</div>
        <div class="ui-g-2 label-font">Tenure Conversion Factor</div>
        <div class="ui-g-2"><span *ngIf="responseDetails.loanEntityValue.tenureConvFactor!=null">{{responseDetails.loanEntityValue.tenureConvFactor.amount}}</span></div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Monthly Tax & Ins</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.mthyTiWhldAmt}}</div>
        <div class="ui-g-2 label-font">Date-Time Stamp</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.lstStatChangeDt!=null">{{responseDetails.loanEntityValue.lstStatChangeDt.date}}</span>
        </div>
        <div class="ui-g-2 label-font">UPB at Sale</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.upbatSaleAmt | currency}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">MERS ID</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.mers}}</div>
        <div class="ui-g-2 label-font">Loan Purpose Code</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.loanPurposeCode}}</div>
        <div class="ui-g-2 label-font">Sales Price</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.salesPrice}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Loan Originator ID</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.loanOriginatorID}}</div>
        <div class="ui-g-2 label-font">Loan Originator Company ID</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.loanOriginatorCompanyID}}</div>
        <div class="ui-g-2 label-font">FHA Case# Assigned Date</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.fhaCaseAssignmentDate}}</div>
      </div>

    </div>

    <!-- Calculated Information -->

    <div class="ui-g container grid-conatiner">

      <div class="ui-g-12 grid-header">Calculated Information</div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">UPB</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnUpbAmt | currency}}</div>
        <div class="ui-g-2 label-font">Initial Interest Rate</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.lnInitIntRt!=null">{{responseDetails.loanEntityValue.lnInitIntRt.amount}}%</span>
        </div>
        <div class="ui-g-2 label-font">Expctd Avg Int Rate</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.expdAvgIntRt!=null">{{responseDetails.loanEntityValue.expdAvgIntRt.amount}}%</span>
        </div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Mortg Margin</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.mtgMrgnRt!=null"> {{responseDetails.loanEntityValue.mtgMrgnRt.amount}}%</span>
        </div>
        <div class="ui-g-2 label-font">Mortgage Rate Floor</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.mtgIntRtMin!=null">{{responseDetails.loanEntityValue.mtgIntRtMin.amount}}%</span>
        </div>
        <div class="ui-g-2 label-font">Mortgage Rate Ceiling</div>
        <div class="ui-g-2"><span
          *ngIf="responseDetails.loanEntityValue.mtgCeilMtgIntRt!=null">{{responseDetails.loanEntityValue.mtgCeilMtgIntRt.amount}}%</span>
        </div>
      </div>


      <div class="ui-g-12 ">
        <div class="ui-g-2 label-font">Net Principal Limit</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnNetPrinLmtAmt | currency}}</div>
        <div class="ui-g-2 label-font">Orig Prin Limit</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnOrigPrinLmtAmt | currency}}</div>
        <div class="ui-g-2 label-font">Loan Status Code</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnStatCd}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Borrower's Age</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.brwrAge}}</div>
        <div class="ui-g-2 label-font">CoBorrower's Age</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.cbrwrAge}}</div>
        <div class="ui-g-2 label-font">Commitment Period</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.ctrtCmmtPer}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Serv Fee Set Aside</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnSrvgFeeSetaAmt | currency}}</div>
        <div class="ui-g-2 label-font">ARM Plan Number</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnArmPnNo}}</div>
        <div class="ui-g-2 label-font">Orig Line of Credit</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.locRsrvAmt | currency}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Total Closing Cost</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnClsngCostsTotAmt | currency}}</div>
        <div class="ui-g-2 label-font">Scheduled Payment</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.lnSchdPmtAmt | currency}}</div>
        <div class="ui-g-2 label-font">Adj. Property Value</div>
        <div class="ui-g-2">{{responseDetails.loanEntityValue.propAdjdValAmt}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Interest Rate Type</div>
        <div class="ui-g-2"
             *ngIf="responseDetails.loanEntityValue.loanInterestRateTypeCode!=null">{{responseDetails.loanEntityValue.loanInterestRateTypeCode.code}}</div>
        <div class="ui-g-8"></div>
      </div>

    </div>

    <!-- Property Information -->

    <div class="ui-g container grid-conatiner">

      <div class="ui-g-12 grid-header">Property Information</div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span class="label-font">Address:&nbsp;&nbsp;</span> {{responseDetails.loanEntityValue.propStrAddr}}
        </div>
        <div class="ui-g-4"><span class="label-font">City:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.propCity}} </div>
        <div class="ui-g-4"><span class="label-font">State:&nbsp;&nbsp;</span> {{responseDetails.loanEntityValue.propStCd}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-4"><span class="label-font">Zip:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.propZipCd}} </div>
        <div class="ui-g-4"><span class="label-font">Prop Appraised Value:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.propApprdValAmt | currency}}
        </div>
        <div class="ui-g-4"><span class="label-font">Year House built:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.propStrcBltYrShow!=null">
        {{responseDetails.loanEntityValue.propStrcBltYrShow}}</span></div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span class="label-font">Maximum Claim Amt:&nbsp;&nbsp;</span>
          {{responseDetails.loanEntityValue.lnFclMaxClmAmt | currency}}</div>
        <div class="ui-g-4"><span
          class="label-font">Number of bdrm:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.noOfBdrm}}
        </div>
        <div class="ui-g-4"><span
          class="label-font">Number of Units:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.noOfUnits}}
        </div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-4"><span class="label-font">Dwelling Type:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.propDwlTypCd}}
        </div>
        <div class="ui-g-4"><span class="label-font">Appraiser ID:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.appraiserID}}
        </div>
        <div class="ui-g-4"><span class="label-font">Appraiser Supervisor ID:&nbsp;&nbsp;</span> {{responseDetails.loanEntityValue.appraiserSupervisorID}}
        </div>
      </div>

    </div>

    <!-- Borrower Information -->

    <div class="ui-g container grid-conatiner">

      <div class="ui-g-12 grid-header">Borrower Information</div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span class="label-font">Number of Borrowers:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.noOfBrwrs}} </div>
        <div class="ui-g-4"><span class="label-font">Monthly Income:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.brwrIncmMthyTotAmt | currency}}
        </div>
        <div class="ui-g-4"><span class="label-font">Ethnicity:&nbsp;&nbsp;</span> {{responseDetails.loanEntityValue.brwrEthcyCd}}
        </div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-4"><span class="label-font">Gender:&nbsp;&nbsp;</span> {{responseDetails.loanEntityValue.brwrGndrTypCd}}
        </div>
        <div class="ui-g-4"><span class="label-font">SSN:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrSsn == '999999999' else blankTemplate">
             ***-**-****
          </span>
        </div>
        <div class="ui-g-4"><span class="label-font">Date Of Birth:&nbsp;&nbsp;</span> <span
          *ngIf="responseDetails.loanEntityValue.brwrBirDt!=null else blankTemplate"> {{responseDetails.loanEntityValue.brwrBirDt.date}}</span>
        </div>
      </div>

      <div class="ui-g-12">
        <ng-template #nullTemplate>
          null
        </ng-template>
        <ng-template #blankTemplate>

        </ng-template>
        <div class="ui-g-4"><span
          class="label-font">Race One:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrRcCd1===' '">null</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrRcCd1!==' '">{{responseDetails.loanEntityValue.brwrRcCd1}}</span>
        </div>
        <div class="ui-g-4"><span
          class="label-font">Race Two:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrRcCd2!==' '; else nullTemplate">{{responseDetails.loanEntityValue.brwrRcCd2}}</span>
        </div>
        <div class="ui-g-4"><span
          class="label-font">Race Three:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrRcCd3!==' '; else nullTemplate">{{responseDetails.loanEntityValue.brwrRcCd3}}</span>
        </div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-4"><span class="label-font">Race Four:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrRcCd4!==' '; else nullTemplate">{{responseDetails.loanEntityValue.brwrRcCd4}}</span>
        </div>
        <div class="ui-g-4"><span
          class="label-font">Race Five:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.brwrRcCd5!==' '; else nullTemplate">{{responseDetails.loanEntityValue.brwrRcCd5}}</span>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span
          class="label-font">Borrower First Name:  </span>
          <!-- Check if value is not null and value is not all spaces -->
          <span *ngIf="responseDetails.loanEntityValue.borrowerFirstName != null &&
            responseDetails.loanEntityValue.borrowerFirstName.split(' ').join('').length > 0
            else blankTemplate"> *******</span>
        </div>
        <div class="ui-g-4"><span
          class="label-font">Borrower Middle Name:  </span>
          <!-- Check if value is not null and value is not all spaces -->
          <span *ngIf="responseDetails.loanEntityValue.borrowerMiddleName != null &&
            responseDetails.loanEntityValue.borrowerMiddleName.split(' ').join('').length > 0
            else blankTemplate"> *******</span>
        </div>
        <div class="ui-g-4"><span
          class="label-font">Borrower Last Name:  </span>
          <!-- Check if value is not null and value is not all spaces -->
          <span *ngIf="responseDetails.loanEntityValue.borrowerLastName != null &&
            responseDetails.loanEntityValue.borrowerLastName.split(' ').join('').length > 0
            else blankTemplate"> *******</span>
        </div>
      </div>

    </div>

    <!-- CoBorrower Information -->

    <div class="ui-g container grid-conatiner last-child-grid-conatiner">

      <div class="ui-g-12 grid-header">CoBorrower Information</div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span class="label-font">SSN:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.cbrwrSsn == '999999999' else blankTemplate">
             ***-**-****
          </span>
        </div>
        <div class="ui-g-4"><span class="label-font">2nd CoBrwr SSN:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.cbrwr2Ssn == '999999999' else blankTemplate">
             ***-**-****
          </span>
        </div>
        <div class="ui-g-4"><span class="label-font">Ethnicity:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrEthcyCd}}
        </div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-4"><span class="label-font">Gender:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrGndrTypCd}}
        </div>
        <div class="ui-g-4"><span class="label-font">Date Of Birth:&nbsp;&nbsp;</span>
          <span *ngIf="responseDetails.loanEntityValue.cbrwrBirDt != null else blankTemplate"> {{responseDetails.loanEntityValue.cbrwrBirDt}}</span>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span class="label-font">Race One:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrRcCd1}}
        </div>
        <div class="ui-g-4"><span class="label-font">Race Two:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrRcCd2}}
        </div>
        <div class="ui-g-4"><span class="label-font">Race Three:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrRcCd3}}
        </div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-4"><span class="label-font">Race Four:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrRcCd4}}
        </div>
        <div class="ui-g-4"><span class="label-font">Race Five:&nbsp;&nbsp;</span>{{responseDetails.loanEntityValue.cbrwrRcCd5}}
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><span class="label-font">CoBorrower First Name:  </span>
          <!-- Check if value is not null and value is not all spaces -->
          <span *ngIf="responseDetails.loanEntityValue.coBorrowerFirstName != null &&
            responseDetails.loanEntityValue.coBorrowerFirstName.split(' ').join('').length > 0
            else blankTemplate"> *******</span>
        </div>
        <div class="ui-g-4"><span class="label-font">CoBorrower Middle Name:  </span>
          <!-- Check if value is not null and value is not all spaces -->
          <span *ngIf="responseDetails.loanEntityValue.coBorrowerMiddleName != null &&
            responseDetails.loanEntityValue.coBorrowerMiddleName.split(' ').join('').length > 0
            else blankTemplate"> *******</span>
        </div>
        <div class="ui-g-4"><span class="label-font">CoBorrower Last Name:  </span>
          <!-- Check if value is not null and value is not all spaces -->
          <span *ngIf="responseDetails.loanEntityValue.coBorrowerLastName != null &&
            responseDetails.loanEntityValue.coBorrowerLastName.split(' ').join('').length > 0
            else blankTemplate"> *******</span>
        </div>
      </div>

      <div class="button-right-cancel">
        <button fmButton type="button" label="Cancel" [small]="true" (click)="cancel()" class="buttonmargin"></button>
      </div>

    </div>
  </div>

  <app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
</div>
